<template>
    <console-layout width="100%" max-width="800">

        <console-title>
            <span>회원등급</span>
        </console-title>

        <console-body>
            <v-data-table :items="levels" :headers="levelsHeaders" hide-default-footer disable-sort disable-pagination class="mt-2 mx-1 elevation-1">
                <template slot="item.actions" slot-scope="{item}">
                    <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)"/>
        </console-body>


        <v-btn fab fixed bottom right color="accent" @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import { mdiMicrosoftExcel, mdiWatermark } from "@mdi/js";

export default {
    components: {
        ConsoleContent
    },
    data(){
        return {
            show: false,

            mdiWatermark,
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            levels: [],
            levelsHeaders: [
                { text: "이름", value: "name", align: "center", width: 200 },
                { text: "코드", value: "code", align: "center", width: 200 },
                // { text: "포인트 적립금(원)", value: "pointPrice.purchase", align: "center" },
                { text: "포인트 적립률(%)", value: "pointPercent.purchase", align: "center" },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "등급 명칭", value: "name" },
                { text: "등급 코드", value: "code" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, levels } = await api.console.member.levels.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.levels = levels;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        create(){
            this.$router.push(`/console/member/levels/create`);
        },
        edit(level){
            this.$router.push(`/console/member/levels/${level._id}`);
        },
        async remove(level){
            if(confirm("삭제하시겠습니까?")){
                await api.console.member.levels.delete(level);
                this.search(false);
            }
        },

        async excel(){
            let { levels } = await api.console.member.levels.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            levels.forEach(level => {
                rows.push({
                    "no": level.no,
                    "이름": level.name,
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "엑셀시트이름");
            XLSX.writeFile(workbook, "엑셀파일이름.xlsx");
        }
    }
}
</script>